import * as Sentry from "@sentry/react";

export const normalizeFrontendChannel = channel => {
  switch (channel) {
    case "alpha":
    case "beta":
    case "stable":
    case "main":
      return channel;
    default:
      return "main";
  }
};

export const getFrontendChannel = envChannel => normalizeFrontendChannel(envChannel);

export const getBuildEnvironmentFromChannel = channel => {
  return normalizeFrontendChannel(channel) === "main" ? "dev" : "prod";
};

export const setSentryBackendChannelContext = settings => {
  const backendChannel = settings?.backendChannel || "default";

  Sentry.setTag("backendChannel", backendChannel);
};
